export default {
  'order.FailedToGetPaymentLink': '获取支付链接失败',
  'order.DidntGetPaymentToken': '没获取到支付token',
  'order.TheSystemIsDesertedPleasePayAgain': '系统开小差啦，请重新支付',
  'order.FailedToCreateAlipayPrepaidOrder': '创建支付宝预付单失败!',
  'order.FailedToGetPaymentInformation': '获取支付信息失败',
  'order.MallCashierPagepaymentMethod': '商城收银台页_支付方式',
  'order.MallCashierPageorderButton': '商城收银台页_下单按钮',
  'order.return': '返回',
  'order.agreeAndContinue': '同意并继续',
  'order.AfterWeChatAuthorizationYouCanEnterTheAccessRequestingAuthorization':
    '微信授权后可进入访问，请求授权中···',
  'order.TheSystemIsOutOfOrder': '系统开小差啦',
  'order.TheSystemIsDesertedPleaseTryAgainLater': '系统开小差啦，请稍后再试',
  'order.PaymentFailed': '支付失败!',
  'order.paymentSuccessful': '支付成功',
  'order.SuccessfullyPaidJumpingIn': '已支付成功，正在跳转中...',
  'order.WeChat': '微信',
  'order.HuabeiInstallment': '花呗分期',
  'order.AlipayScanCodePayment': '支付宝扫码支付',
  'order.ScanCodePayment': '扫码付',
  'order.QueryFailedPleaseTryAgain': '查询失败请重试',
  'order.ThePaymentIsSuccessfulPleaseReturnToWeChatToContinueTheOperation':
    '支付成功，请返回微信继续操作',
  'order.MallCashierPagePaymentConfirmationPopup': '商城收银台页_支付确认弹窗',
  'order.ParameterError': '参数错误!',
  'order.NoPaymentResultDetected': '没有检测到支付结果',
  'order.IfYouHaveAlreadyPaidPleaseClickRefreshToQueryTheResults':
    '若已经支付 请点击刷新进行结果查询',
  'order.payAgain': '重新支付',
  'order.MallCashierPagepaymentConfirmationPopupconfirmationButton':
    '商城收银台页_支付确认弹窗_确认按钮',
  'order.refresh': '刷新',
  'order.MallCashierPagePaymentConfirmationPopupCloseButton': '商城收银台页_支付确认弹窗_关闭按钮',
  'order.Minute': '分',
  'order.Expect': '期',
  'order.0HandlingFee': '0手续费',
  'order.IncludingHandlingFee': '含手续费￥',
  'order.perIssue': '/每期',
  'order.recommend': '推荐',
  'order.PleaseConfirmThatYouHaveReadAndAgree': '请确认您已阅读并同意',
  'order.UserServicesAgreement': '《用户服务协议》',
  'order.AfterPayingYouNeedToComeBackToConfirmThePaymentResultToEnsureTheSmoothDistributionOfThePurchasedContent':
    '支付后需要回来确认支付结果，确保购买内容顺利发放！',
  'order.PaymentAmount': '支付金额',
  'order.readAndAgree': '已阅读并同意',
  'order.AreYouSureYouWantToForgoPayment': '您确定要放弃支付吗？'
};
